import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { concatMap, map, tap } from 'rxjs/operators';
import { SaveCardServiceReqParamsModel } from '../../models/save-card-service-models';
import { SaveCardPaymentInfo } from '../../models/transaction-request-models';
import { TransactionResultReqParamsModel } from '../../models/transaction-result-models';
import { es3dgateService } from '../../services/3dsgate/3dsRequest.service';
import { SaveCardService } from '../../services/save-card/save-card.service';
import { TranscationRequestService } from '../../services/transaction-request/transcation-request.service';

@Component({
  selector: 'app-card-save',
  templateUrl: './card-save.component.html',
  styleUrls: ['./card-save.component.css']
})
export class CardSaveComponent implements OnInit {
  @Output() paramsEmitter = new EventEmitter<TransactionResultReqParamsModel>();
  @Output() amountEmitter = new EventEmitter<string>();

  public bankSaveCardPage!:any;

  private subscriptions = new Subscription();

  constructor(
    private transactionRequestService: TranscationRequestService,
    private sanitizer: DomSanitizer,
    private es3dgateService: es3dgateService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(){
    this.subscriptions.add(
      this.transactionRequestService.TransactionRequest<null, SaveCardPaymentInfo>('card-save')
      .pipe(
        tap(paymentInfo => {
          const amount = paymentInfo.posInfo.Amount;
          const transactionCompleteReqParams:TransactionResultReqParamsModel = {
            merchantId: paymentInfo.merchantId,
            orderId: paymentInfo.orderId,
            refCode: paymentInfo.refCode
          };

          this.amountEmitter.emit(amount);
          this.paramsEmitter.emit(transactionCompleteReqParams);
          localStorage.setItem('payment-type', JSON.stringify('card-save'));
        }),
        map((paymentInfo:SaveCardPaymentInfo) => {

          let saveCard:SaveCardServiceReqParamsModel = {
            redirectURL: paymentInfo.redirectURL,
            clientid: paymentInfo.posInfo.ClientId,
            storetype: paymentInfo.posInfo.StoreType,
            hash: paymentInfo.posInfo.Hash,
            amount: paymentInfo.posInfo.Amount,
            currency: paymentInfo.posInfo.Currency,
            okUrl: paymentInfo.posInfo.OkUrl,
            failUrl: paymentInfo.failURL,
            rnd: paymentInfo.posInfo.Rnd,
            MERCHANTSAFEKEY: paymentInfo.merchantId,
            DESCRIPTION: paymentInfo.extraData,
            oid: paymentInfo.posInfo.Oid
          }

          return saveCard;
        }),
        concatMap(saveCardParameters => 
          this.es3dgateService
            .service3dsRequest<SaveCardServiceReqParamsModel>('card-save', saveCardParameters)!
        ),
      )
      .subscribe(
        resp => {
          this.bankSaveCardPage = this.sanitizer.bypassSecurityTrustHtml(resp);
        },
        err =>{
          this.toastr.error(err);
          this.router.navigate(['/home']);
        }
      )
    );

  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

}